import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import styles from "./avatar.module.scss";


interface IProps {
  size: number;
  icon: IconProp;
  iconSize?: number;
  disableShadow?: boolean;   
}

const Avatar: React.FC<IProps> = (props) => {

  const inlineStyle = {
    minWidth: `${props.size}px`,
    minHeight: `${props.size}px`,
    fontSize: props.iconSize !== undefined ? `${props.iconSize}rem` : '1.25rem'
  }

  const getClasses = (disabaleShadow?: boolean) => {
    let shadow = disabaleShadow !== undefined ? " shadow-none border-0" : "";
    return `${styles.avatar}${shadow}`;
  }

  return (
    <div className={getClasses(props.disableShadow)} style={inlineStyle}>
      <FontAwesomeIcon icon={props.icon} />
    </div>
  ) 
};

export default Avatar;
